import type { UnknownAction } from '@reduxjs/toolkit';
import { createAction } from '@reduxjs/toolkit';
import type { Price } from '../../../../ssr/src/Outlet/ShoppingCart/ShoppingCartSchema';

interface PricesAction extends UnknownAction {
  payload: string;
  type: PricesActionType;
}

export enum PricesActionType {
  ADD_DISCOUNT_CODE = 'ADD_DISCOUNT_CODE',
  DISCOUNT_CODE_IS_INVALID = 'DISCOUNT_CODE_IS_INVALID',
  RECALCULATE_PRICES = 'RECALCULATE_PRICES',
  RESET_DISCOUNT_CODE = 'RESET_DISCOUNT_CODE',
  RESET_VOUCHER_CODE = 'RESET_VOUCHER_CODE',
  SET_ALL_PRICES = 'SET_ALL_PRICES',
  SET_ALL_PRICES_DATA = 'SET_ALL_PRICES_DATA',
  SET_IS_DISCOUNTED = 'SET_IS_DISCOUNTED',
}

export type AddDiscountCodePayload = { code: string };
export const addDiscountCode = createAction<AddDiscountCodePayload>(
  PricesActionType.ADD_DISCOUNT_CODE,
);

export const invalidateDiscountCode = createAction(
  PricesActionType.DISCOUNT_CODE_IS_INVALID,
);
export const recalculatePrices = createAction(
  PricesActionType.RECALCULATE_PRICES,
);
export const resetDiscountCode = createAction(
  PricesActionType.RESET_DISCOUNT_CODE,
);
export const resetVoucherCode = createAction(
  PricesActionType.RESET_VOUCHER_CODE,
);

export type SetAllPricesPayload = {
  discount: number;
  shippingPrice: number;
  subTotal: number;
  total: number;
  voucher: number;
};
export const setAllPrices = createAction<SetAllPricesPayload>(
  PricesActionType.SET_ALL_PRICES,
);

export type SetAllPricesDataPayload = {
  discount: Price;
  discountCode: string;
  hasDiscount: boolean;
  shippingPrice: Price;
  subTotal: Price;
  total: Price;
  voucher: Price;
  voucherCode: string;
};
export const setAllPricesData = createAction<SetAllPricesDataPayload>(
  PricesActionType.SET_ALL_PRICES_DATA,
);

export type SetIsDiscountedPayload = { hasDiscount: boolean };
export const setIsDiscounted = createAction<SetIsDiscountedPayload>(
  PricesActionType.SET_IS_DISCOUNTED,
);

export type { PricesAction };
